import { AdminDataProvider } from 'src/app/hubadmin/shared/providers/master-provider/admin-data.provider';
import { MysteryTemplateModel, MysteryCampaignModel, MysteryTemplateAssignedUsersModel } from './../../../shared/models/mystery-shopper';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, THEME } from 'ng-wizard';
import { of } from 'rxjs';
import { ChannelModel } from 'src/app/hubadmin/shared/models/channel';
import { ExcelModel, GeographyModel } from 'src/app/hubadmin/shared/models/geography';
import { RegionModel } from 'src/app/hubadmin/shared/models/region';
import { StateModel } from 'src/app/hubadmin/shared/models/state';
import { ChannelProvider } from 'src/app/hubadmin/shared/providers/channel.provider';
import { GeographyProvider } from 'src/app/hubadmin/shared/providers/geography.provider';
import { RegionProvider } from 'src/app/hubadmin/shared/providers/region.provider';
import { StateProvider } from 'src/app/hubadmin/shared/providers/state.provider';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';

@Component({
  selector: 'app-add-edit-templates',
  templateUrl: './add-edit-templates.component.html',
  styleUrls: ['./add-edit-templates.component.scss']
})
export class AddEditTemplatesComponent implements OnInit {
  regionList: RegionModel[];
  channelList: ChannelModel[];
  geography: GeographyModel[];
  states: StateModel[];
  mysteryCampaign: MysteryCampaignModel[];
  AssignedUsers: MysteryTemplateAssignedUsersModel[];
  submitted = false;
  id: number;
  headerText: string = "Add";
  page: any = 1;
  getPaginationCount: number;

  submittedLevels: any = { isSubmitted: true, state: "engagement" };

  config: NgWizardConfig = {
    // selected: 0,
    anchorSettings: { anchorClickable: true },
    theme: THEME.default,
  };


  _form: FormGroup;
  _parameters: any;

  @Input() model: MysteryTemplateModel = new MysteryTemplateModel();
  tempOptionModel: any;


  constructor(public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    public activatedRoute: ActivatedRoute,
    public AdminDataProvider: AdminDataProvider,
    private router: Router,
    private formBuilder: FormBuilder,
    private formateDate: DateFormateService,
    public alertService: AlertService,
    public exportExcelService: ExportExcelService,
    private xlsx: XlsxService,
    private modalService: NgbModal,
    private uploadFile: UploadZipService,
    public ngWizardService: NgWizardService,
    public regionProviders: RegionProvider,
    public stateProviders: StateProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider) {


    this._form = this.formBuilder.group({
      template_name: ["", Validators.required],
      start_date: ["", Validators.required],
      end_date: ["", Validators.required],
      region_id: ["", Validators.required],
      channel_id: ["", Validators.required],
      mystery_campaign_id: ["", Validators.required],
    });

    this.uploadFile.currentMessage.subscribe((message) => {
      if (message.status == "success") {
        this.getAssignedUsers();
      }
    });
  }

  ngOnInit() {
    this._parameters = this.activatedRoute.params.subscribe((params) => {
      if (typeof params["id"] !== "undefined") {
        if (params["id"] !== "") {
          this.id = Number.parseInt(params["id"]);
          this.getMysteryTemplateConfig(this.id);
          this.getAllMysteryCampaign();
          this.headerText = "Edit";
          this.getAssignedUsers();
        }
      }
    });
  }


  getMysteryTemplateConfig(id) {
    this.apiService
      .getHeaders(this.apiConfig.getAllmysteryTemplate + "?id=" + id)
      .subscribe(
        (res: any) => {
          this.model = res.body.data as MysteryTemplateModel;
          this.model.show = false;
          this.model.statusString = (this.model.status == 1) ? "Active" : "Inactive";
          if (new Date(this.model.start_date) >= new Date()) {
            this.model.show = true;
          }
          let dates = {
            start: this.model.start_date.split("-"),
            end: this.model.end_date.split("-"),
          };
          let startDate = {
            year: parseInt(dates.start[0]),
            month: parseInt(dates.start[1]),
            day: parseInt(dates.start[2]),
          };
          let endDate = {
            year: parseInt(dates.end[0]),
            month: parseInt(dates.end[1]),
            day: parseInt(dates.end[2]),
          };
          this.model.startDate = startDate;
          this.model.endDate = endDate;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getAllMysteryCampaign() {
    this.apiService.getHeaders(this.apiConfig.getAllMysteryCampaign)
      .subscribe((res: any) => {
        this.mysteryCampaign = res.body.data;
      }, err => {
        console.log(err);
      })
  }


  ngDoCheck() {
    this.regionList = this.regionProviders.regions;
    this.channelList = this.channelProviders.channels;
    this.geography = this.geoProviders.geography;
    this.states = this.stateProviders.state;
  }


  // convenience getters for easy access to form fields
  get f() {
    return this._form.controls;
  }


  /* wizard section start */
  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  stepChanged(args: StepChangedArgs) {
    this.submittedLevels.state = args.step.index;
  }
  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }

  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }

  createMysteryTemplate() {
    this.apiService
      .post(this.apiConfig.createMysteryTemplate, this.model)
      .subscribe((res: any) => {
        if (res.body.status) {
          this.alertService.success(res.body.data.message);
          this.id = res.body.data.id;
          this.showNextStep();
        }
      });
  }

  updateMysteryTemplate() {
    this.apiService
      .put(
        this.apiConfig.updatemysteryTemplate + "?id=" + this.model.id,
        this.model
      )
      .subscribe((res: any) => {
        if (res.status) {
          this.alertService.success(res.data.message);
          this.clearSuccess();
          this.showNextStep();
        }
      });
  }

  reset() {
    this._form.reset();
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  changeUserStatus(item: any) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateWhiteOutlistMysteryCampaign + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
      });
  }

  onSubmit() {
    this.submitted = true;
    if (this._form.invalid) {
      return;
    }
    this.model.start_date = this.formateDate.formateDate(this.model.startDate);
    this.model.end_date = this.formateDate.formateDate(this.model.endDate);
    if (this.model.id != null) {
      this.updateMysteryTemplate();
    } else {
      this.createMysteryTemplate();
    }
  }


  onReset() {
    // reset whole form back to initial state
    this.submitted = false;
    this._form.reset();
  }

  onClear() {
    // clear errors and reset ticket fields
    this.submitted = false;
    this._form.reset();;
  }


  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  downloadExcel() {
    this.exportExcelService.exportUserAssignment();
  }


  paginationClick(pageNumber) {
    this.page = pageNumber;
    this.getAssignedUsers();
  }


  getAssignedUsers() {
    this.apiService
      .getHeaders(this.apiConfig.getAllTemplateAssignedUsers + "?template_id=" + this.id + "&page=" + this.page)
      .subscribe(
        (res: any) => {
          if (res.body.data) {
            this.AssignedUsers = res.body.data;
            this.getPaginationCount = res.headers.get(
              "X-Pagination-Total-Count"
            );
            if (this.AssignedUsers.length > 0) {
              this.AssignedUsers.forEach(
                a => {
                  a.show = false;
                  a.statusString = a.status == 1 ? "Active" : "Inactive";
                  if (this.model.show == true) {
                    a.show = true;
                  }
                }
              )
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }


  uploadXlsx(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  excel: ExcelModel = new ExcelModel();
  xlsxView(data) {
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.uploadMultiData(this.excel);
        }
      },
      (reason) => { }
    );
  }

  closeoptionModel() {
    this.tempOptionModel.close();
  }

  uploadMultiData(data) {
    data.excel_data.filter(i => {
      i["rocode"] = i["Outlet Code"]
      delete i["Outlet Code"];
      delete i.isEdit;
    })
    let payload = {
      "template_id": this.id,
      "users": data.excel_data
    }
    console.log(payload)
    this.enableUploadDiv(payload);
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.BulkLoadMysteryUserTemplate,
      module: "User Assigment",
      zip: "no",
      excelname: "User Assignment Excel",
    });
  }

}
